import type { ComponentType, HTMLAttributes } from "react";

export interface FeatureItemProps {
    icon: ComponentType<HTMLAttributes<HTMLOrSVGElement>>;
    title: string;
    description: string;
}

export function FeatureItem({ icon: Icon, title, description }: FeatureItemProps) {
    return (
        <div className="flex min-w-0 flex-1 gap-3">
            <div className="grid size-10 shrink-0 place-items-center rounded-xl bg-primary/10">
                <Icon className="size-5 text-primary" aria-hidden />
            </div>
            <div className="min-w-0">
                <p className="font-display text-sm font-semibold text-left text-foreground">{title}</p>
                <p className="mt-0.5 text-xs leading-snug text-left text-muted-foreground">{description}</p>
            </div>
        </div>
    );
}

